import React, {useEffect} from 'react';
import {Flex, Button } from "antd";
import {SearchOutlined, ControlOutlined, ControlFilled, ControlTwoTone } from "@ant-design/icons";
import SearchInput from "./SearchInput";
import SettingsPanel from "./SettingsPanel";
import './search-bar.css'

const SearchBar = ({
                       query,
                       isSearching = false,
                       settings,
                       queries = [],
                       handleSettings,
                       handleSearch,
                       clearSearch
}) => {
    const [searchValue, setSearchValue ] = React.useState('');

    useEffect(() => setSearchValue(query), [query]);

    const changeViewSettings = (visible) => {
        handleSettings({ ...settings, view: visible})
    }

    const toggleViewSettings = () => settings.view
        ? changeViewSettings(false)
        : changeViewSettings(true);

    const settingsIcon = settings.view
        ? <ControlFilled />
        : settings.type && settings.type.length === 1 ? <ControlTwoTone /> : <ControlOutlined />;

    return (
        <div className="search-bar">
            <Flex horizontal="true"  gap={10}>
                <Button type="text"
                        style={{fontSize: '26px'}}
                        icon={ settingsIcon }
                        onClick={toggleViewSettings}
                />
                <SearchInput
                    value={searchValue}
                    queries={queries}
                    onChange={setSearchValue}
                    handleSearch={(v) => {
                        setSearchValue(v)
                        handleSearch(v)}
                    }
                    onClear={clearSearch}
                />
                <Button
                    type="primary"
                    icon={<SearchOutlined/>}
                    onClick={() => handleSearch(searchValue)}
                    loading={isSearching}
                >
                    Поиск
                </Button>
            </Flex>
            {settings.view && <SettingsPanel settings={settings} handleSettings={handleSettings}/>}
        </div>
    )
}

export default SearchBar;
